import { useSyncExternalStore } from 'react';

import type { JustCallDialerBridge } from './justcallDialerBridge';
import { getJustCallDialerBridge } from './justcallDialerBridge';
import { JustCallDockPanel } from './JustCallDockPanel';

export interface JustCallDockProps {
  /** Defaults to the page-wide bridge; injectable for tests. */
  bridge?: JustCallDialerBridge;
}

/**
 * Home of JustCall's dialer (see `justcallDialerBridge`). Mounted once per surface at the softphone
 * provider (dashboard root, extension side-panel root) and renders nothing until something asks for
 * JustCall — a JustCall call, or "Open JustCall dialer" in settings — so teams on other carriers
 * never load it, and server rendering never reaches the browser-only panel.
 */
export function JustCallDock({ bridge = getJustCallDialerBridge() }: JustCallDockProps) {
  const state = useSyncExternalStore(bridge.subscribe, bridge.getSnapshot, bridge.getServerSnapshot);
  if (!state.active) return null;
  return <JustCallDockPanel bridge={bridge} state={state} />;
}
